module.exports = __webpack_public_path__ + "static/media/icon2-active.b2e8dfc6.svg";